
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service_unavailable",
      function () {
        return require("private-next-pages/service_unavailable.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service_unavailable"])
      });
    }
  